class ScrollSlider {
    constructor() {
        this.wrapper = null;
        this.sliderButton = null;
        this.overlay = null;
        this.startingX = 0;
        this.overlayStartingX = 0;
        this.overlayStartingY = 0;
    }

    /**
     * Инициализация модуля
     * @param {object} options - параметры
     */
    init(options) {
        this.wrapper = options.wrapper;
        this._getElements();
        this._bindEvents();
    }

    /**
     * Получаем элементы со страницы
     * @private
     */
    _getElements() {
        this.inner = this.wrapper?.querySelector('.j-scroll-slider-inner');
        this.sliderButton = this.wrapper?.querySelector('.j-scroll-slider');
        this.overlay = this.wrapper?.querySelector('.j-scroll-slider-overlay');
    }

    _bindEvents() {
        this.sliderButton.addEventListener('touchstart', this._moveInnerStart.bind(this));
        this.sliderButton.addEventListener('touchmove', this._moveInnerMove.bind(this));
        this.overlay.addEventListener('touchstart', this._overlayMoveStart.bind(this));
        this.overlay.addEventListener('touchmove', this._overlayMove.bind(this));
        this.inner.addEventListener('scroll', this._moveSlider.bind(this));
    }

    _overlayMoveStart(event) {
        this.overlayStartingX = event.touches[0].clientX;
        this.overlayStartingY = event.touches[0].clientY;
    }

    _overlayMove(event) {
        const currentX = event.touches[0].clientX;
        const currentY = event.touches[0].clientY;
        const scrollX = currentX - this.overlayStartingX;
        const scrollY = currentY - this.overlayStartingY;

        if (Math.abs(scrollX) > Math.abs(scrollY)) {
            this.overlay.style.display = 'none';
        }
    }

    _moveInnerStart(event) {
        if (this.startingX === 0) {
            this.startingX = event.touches[0].clientX;
        }

        this.overlay.style.display = 'none';
    }

    _moveInnerMove(event) {
        const currentX = event.touches[0].clientX;
        const scroll = currentX - this.startingX;
        const total = this.inner.scrollWidth - this.inner.clientWidth;


        if (scroll >= 0 && scroll <= total) {
            this.inner.scrollTo(scroll * 5, 0);
        }
    }

    _moveSlider() {
        const scroll = this.inner.scrollLeft;
        const total = this.inner.scrollWidth - this.inner.clientWidth;

        this.sliderButton.style.left = `${(scroll / total) * 100}%`;
        this.sliderButton.style.transform = `translateX(-${(scroll / total) * 100}%)`;
    }
}


export default ScrollSlider;
